import {Base} from "@/api/Base"

export class OvertimeApplicationReject extends Base {
    path = "overtimeApplication/reject"
}